import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const MachineNotFound = () => {
  const { t } = useTranslation();

  return (
    <Stack role="status" data-test-id="machine-not-found" spacing={2} alignItems="center" sx={{ p: 4 }}>
      <Typography variant="h5" component="h1">
        {t('errors.machine.machine_not_found')}
      </Typography>
      <Typography>{t('errors.machine.not_found_description')}</Typography>
      <Button component={Link} to="/dashboard" variant="contained" data-test-id="machine-not-found-back-button">
        {t('errors.machine.back_to_machines')}
      </Button>
    </Stack>
  );
};

export default MachineNotFound;
